// frontend/src/contexts/LibrarianTopbarContext.tsx
import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';

interface TopbarState {
  title: string;
  subtitle: string | null;
  setTitle: (t: string) => void;
  setSubtitle: (s: string | null) => void;
}

const TopbarCtx = createContext<TopbarState | undefined>(undefined);

export const LibrarianTopbarProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [title, setTitle] = useState('Dashboard');
  const [subtitle, setSubtitle] = useState<string | null>(null);
  return (
    <TopbarCtx.Provider value={{ title, subtitle, setTitle, setSubtitle }}>
      {children}
    </TopbarCtx.Provider>
  );
};

export const useLibrarianTopbar = (next?: { title?: string; subtitle?: string | null }) => {
  const ctx = useContext(TopbarCtx);
  if (!ctx) throw new Error('useLibrarianTopbar must be inside LibrarianTopbarProvider');
  useEffect(() => {
    if (next?.title !== undefined) ctx.setTitle(next.title);
    if (next?.subtitle !== undefined) ctx.setSubtitle(next.subtitle);
  }, [next?.title, next?.subtitle]); // eslint-disable-line react-hooks/exhaustive-deps
  return ctx;
};
